/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

// export var Globals = {};

export var Status = {
	CONNECTED: 1,
	DISCONNECTED: 2
};

export var ErrorTypes = {
	DISCONNECT: '1000',
	GENERAL_ERROR: '100',
	INVALID_MESSAGE: '101',
	INVALID_SERVICE: '102',
	CONCURRENT_CONNECTION: '103',
	ALREADY_LOGGED_IN: '104',
	NOT_LOGGED_IN: '105',
	SESSION_CLOSED: '105',
	INVALID_TRANSFER: '106',
	INVALID_BET_AMOUNT: '107',
	INSUFFICIENT_FUNDS: '108',
	INVALID_BET: '109',
	INVALID_SESSION: '110',
	MAX_BET_LIMIT: '115',
	BET_TIMEOUT: '112',
	FREESPIN_ERROR: '117',
	FREESPIN_EXPIRED: '118'
};

export const EVENTS = {
	REEL_FINISHED: 'reel_finished',
	REEL_STARTED: 'reel_started',
	LINE_STARTED: 'line_started',
	LINE_FINISHED: 'line_finished',
	ALL_LINES_FINISHED: 'allline_finished',
	REEL_CAN_STOP: 'reel_can_stop',
	MODAL: 'modal',
	WIN_HIGHLIGHT: 'win_hightlight',
	AUTO_STARTED: 'auto_started',
	SETTINGS_UPDATE: 'settings_update',
	SERVER_MSG: 'server_msg',
	ERROR_MSG: 'error_msg',
	ERROR_PAGE: 'error_page',
	NOTIFICATION: 'notification',
	BET_UPDATE: 'bet_update',
	BONUS_ROUND_STATE: 'bonus_round_state',
	DOUBLE_CHANCE: 'double_chance',
	BET_PLACED: 'bet_placed',
	PAUSE: 'pause',
	START_GAME: 'start_game',
	BONUS_BUY: 'bonus_buy',
	INTERACTION: window.isMobile || window.isTablet ? 'tap' : 'click',
	QUEST_CLAIM: 'quest_claim',
	QUEST_UPDATE: 'quest_update',
	QUEST_END: 'quest_end',
	FREESPIN: 'freespin',
	HAS_QUEST: 'has_quest',
	QUEST_CAN_CLAIM: 'quest_can_claim',
	BONUS_RESTORE: 'bonus_restore',
	IS_DISABLED: 'disable',
	BAIT: 'bait',
	MAIN_LINE_FINISHED: 'main_line_finished',
	ICON_CLICKED: 'icon_clicked',
	INFO: 'info'

	// CLICKABLE: 'clickable'
};

export const COMPONENTS = {
	QUEST_WIDGET: 'quest_widget_holder',
	QUEST_PAGE: 'quest_page_holder',
	QUEST_PAGE_CLAIM: 'quest_page_claim_holder',
	BONUS_BUY_WIDGET: 'bonus_buy_widget_holder',
	BONUS_BUY_PAGE: 'bonus_buy_page_holder',
	BONUS_REVIVE_PAGE: 'bonus_revive_page_holder',
	NOTIFICATION: 'notification_holder',
	SETTINGS_PAGE: 'settings_page_holder',
	INFO_PAGE: 'info_page_holder',
	AUTO_SPIN: 'auto_spin_page_holder',
	WIN_HIGHLIGHT: 'win_highlight_holder',
	FAST_PLAY_DIALOGUE: 'fast_play_dialogue_holder',
	FREE_SPIN_WIN: 'free_spin_win_holder',
	BONUS_GAME_DIALOGUE: 'bonus_game_dialogue_holder',
	BONUS_GAME_FINISHED_DIALOGUE: 'bonus_game_finished_holder',
	DOUBLE_CHANCE_WIDGET: 'double_chance_widget_holder',
	LOGO: 'logo_holder',
	BET_AMOUNT: 'bet_amount_holder',
	STATUS_BAR: 'status_bar_holder',
	STATUS_BAR_BG: 'status_bar_bg_holder',
	STATUS_BAR_BG_DESKTOP: 'status_bar_bg_holder_desktop',
	INFO_BUTTONS: 'info_buttons_holder',
	SPIN_BUTTONS: 'spin_buttons_holder',
	REEL: 'reel_holder',
	BONUS_GAME: 'bonus_game_holder',
	PROMPT: 'prompt_holder',
	QUEST_PROMPT: 'quest_prompt_holder',
	FREESPIN_PROMPT: 'freespin_prompt_holder',
	FREESPIN_STATUS_BAR: 'freespin_status_bar_holder',
	QUEST_STATUS_BAR: 'quest_status_bar_holder',
	BONUS_TRIGGER: 'bonus_trigger_holder',
	WIN_AMOUNT: 'win_amount_holder',
	WIN_INFO: 'win_info_holder'
};

export const NOTIFICATIONS = {
	100: {
		title: 'GENERAL ERROR',
		desc: 'Something went wrong. Please reload the page.'
	},
	101: {
		title: 'INVALID MESSAGE',
		desc: 'Invalid action.'
	},
	102: {
		title: 'INVALID SERVICE',
		desc: 'Invalid action.'
	},
	103: {
		title: 'ANOTHER LOGIN',
		desc: 'Another login has been detected.'
	},
	106: {
		title: 'INVALID TRANSFER',
		desc: 'Money transfer error, please get in touch with support.'
	},
	107: {
		title: 'INVALID BET AMOUNT',
		desc: 'Invalid bet amount.'
	},
	108: {
		title: 'INSUFFICIENT FUNDS',
		desc: 'Insufficient funds, please decrease bet or refill your balance.'
	},
	109: {
		title: 'INVALID BET',
		desc: 'Invalid bet.'
	},
	110: {
		title: 'INVALID SESSION',
		desc: 'Your session has expired. Please reload the page.'
	},
	112: {
		title: 'PLACED BET TIMEOT',
		desc: 'Quest bet timeout'
	},
	1112: {
		title: 'OOPS, TIME`S OUT!',
		desc: 'New quest is available'
	},
	115: {
		title: 'MAX BET LIMIT',
		desc: 'You have exceeded the max bet limit.'
	},
	117: {
		title: 'FREESPIN ERROR',
		desc: 'Something went wrong, please get in touch with support.'
	},
	//TODO, get code
	118: {
		title: 'EXPIRATION NOTIFICATION',
		desc: 'The validity period for free spins has expired'
	}
};

export const ERROR_TEXTS = {
	1000: 'Your session has expired. Please reload the page',
	100: 'Something went wrong. Please reload the page.',
	101: 'Your session has expired. Please reload the page.',
	103: 'Another login has been detected.',
	105: 'Please log in to continue.',
	110: 'Your session has expired. Please reload the page.',
	111: 'your session has expired, please reload the page',
	113: 'your session has expired, please reload the page'
};
